let artisteFilter = $('#artiste-filter');
let disciplineFilter = $('#discipline-filter');
let communeFilter = $('#commune-filter');

function attributeSelect2() {
    $("#artiste-filter").select2();
    $("#discipline-filter").select2();
    $("#commune-filter").select2();
}

$('#artiste-filter, #discipline-filter, #commune-filter').change(function () {
    var artisteId = $("#artiste-filter option:selected").val();
    var disciplineId = $("#discipline-filter option:selected").val();
    var communeId = $("#commune-filter option:selected").val();
    var editionId = $('.filters').attr('data-edition-id');

    $.ajax({
        url: base_url+'artiste-ajax-get/',
        method: 'POST',
        global:false,
        data: {artisteId: artisteId, disciplineId: disciplineId, communeId: communeId, editionId : editionId},
        dataType: "json",
        success: function(data){
            $('.artistes').html(data.html);
        }
    })

});

$(document).ready(function () {
    attributeSelect2();
});


// WEBPACK FOOTER //
// ./src/js/app/liste-artistes.js